import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const {fetchAllVehicleApplication:{executeFetchAllVehicleApplications}} = FetchData

        const { FormRequestGlobal : {onResetForm}} = Forms

        onResetForm()
        executeFetchAllVehicleApplications()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }



    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal:{setFormState} } = Forms

        // const { fetchAllDeposits } = FetchData
        // const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        // executeFetchAllDeposits()

    }

//     const handleClickDeleteDocument = (iddocumento) => {

//         const { fetchAllFiles } = FetchData
//         const { executeFetchAllFiles } = fetchAllFiles
//         Swal.fire({
//             title: '¿Desea eliminar este registro?',
//             showConfirmButton: true,
//             showCancelButton: true,
//             confirmButtonText: 'Eliminar',
//             cancelButtonText: 'Cancelar'
//         }).then(async result => {
//             if (result.isConfirmed) {
//                 await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
//                 .then( ({ data }) => {
//                     alertMessage(data)
//                     if (data.title === 'OK') {
//                         executeFetchAllFiles()
//                         // closeModal()
//                         }else{
                            
//                         }
//                 }).catch(error => {
//                     console.log('API ERROR: ', error)
//                 })
//             }
//         })
//     }

//     const handleClickDeleteDeposit = (iddocumento) => {

//         const { fetchAllDeposits } = FetchData
//         const { executeFetchAllDeposits } = fetchAllDeposits
//         Swal.fire({
//             title: '¿Desea eliminar este registro?',
//             showConfirmButton: true,
//             showCancelButton: true,
//             confirmButtonText: 'Eliminar',
//             cancelButtonText: 'Cancelar'
//         }).then(async result => {
//             if (result.isConfirmed) {
//                 await marvarApi.delete(`/leases/management/delete-deposit/${iddocumento}`)
//                 .then( ({ data }) => {
//                     alertMessage(data)
//                     if (data.title === 'OK') {
//                         executeFetchAllDeposits()
//                         // closeModal()
//                         }else{
                            
//                         }
//                 }).catch(error => {
//                     console.log('API ERROR: ', error)
//                 })
//             }
//         })
//     }

//     const handleChangeTotalMonths = ({ target }) => {
//         // console.log(event);
//         const { FormLeases } = Forms
//         const { formState ,setFormState } = FormLeases

//         // const data = JSON.parse(event.target.value || null)

//         const { name, value } = target;
//         setFormState({
//             ...formState,
//             [ name ]: value,
//             contrato_total_alquiler: (formState.contrato_costo_alquiler * (value || 0))
//         });
//     }

const handleChangeTypeCurrency = (event) => {

    //HOOKS
    const {FormDeposit} = Forms
    const {setFormState, formState} = FormDeposit
    const {deposito_monto, deposito_tipo_cambio} = formState
    
    const { name, value } = event.target

    //Verificamos si tiene data
    const monto = deposito_monto !== '' ? deposito_monto : 0;
    const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

    if (value === 'DOLAR') {
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value,
            deposito_quetzales : (monto*tipo_cambio),
            deposito_dolares : (monto),
        }))
    }else if (value === 'QUETZAL') {
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value,
            deposito_quetzales : (monto),
            deposito_dolares : (monto/tipo_cambio),
        }))
    }
}


    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        handleClickNextStep()
            
    }

    const onSendLogs = async (e) => {

        
        const { FormRequestGlobal } = Forms
        const {formState, setFormState} = FormRequestGlobal

        const { fetchInfoObservations:{executeFetchAllObservations} } = FetchData


        const {getCurrentDate} = Helpers
        
        // const { fetchAllTypeManagements:{typeManagements} } = FetchData
        
        await marvarApi.post(`/vehicle/common/log-vehicle/${formState.idcredito}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
        .then(({data}) => {
            alertMessage(data)
            if (data.title === 'OK') {
                setFormState((prevState) => ({
                    ...prevState,
                    aprobacion_observaciones: ''
                }))
                executeFetchAllObservations()
            }
        })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()
      
        const { FormRequestGlobal:{formState, setFormState} } = Forms
        const {getCurrentDate} = Helpers


        const {fetchAllFiles:{executeFetchAllFiles}, fetchInfoApplication:{executeFetchInfoApplication}} = FetchData

        
        if(formState.acceptedFiles.length<=0){
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return 
        }

        const _data = new FormData();

        _data.append('idcredito', formState.idcredito);
        _data.append('department', 'JURIDICO');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formState.idcredito>0){
            
            await marvarApi.post( `/vehicle/common/create-document`, _data )
                .then(async ({ data }) => {
                    
                    alertMessage(data)
                    setFormState(prevState => ({
                        ...prevState,
                        acceptedFiles : [],
                        fileRejections : []
                    }))
                    executeFetchAllFiles()

                    // if (data.title === 'OK') {
                    //     await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, {aprobacion_check: 'Pendiente Aprobacion Contrato', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate()})
                    //     .then(({ data }) => {
                    //         alertMessage(data)
                    //         executeFetchInfoApplication()
                    //     })
                    //     .catch(error => {
                    //         console.log('API ERROR: ', error)
                    //     })


                    // }
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }
    }

    const handleClickDeleteDocument = (iddocumento) => {

        const {getCurrentDate} = Helpers
        const { fetchAllFiles:{executeFetchAllFiles}, fetchInfoApplication:{executeFetchInfoApplication} } = FetchData
        const { FormRequestGlobal:{formState} } = Forms

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/common/delete-document/${iddocumento}`)
                .then( async ({ data }) => {
                    alertMessage(data)
                    executeFetchAllFiles()
                    // if (data.title === 'OK') {
                    //     await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, {aprobacion_check: 'Pendiente Contrato', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate()})
                    //             .then(({ data }) => {
                    //                 alertMessage(data)
                    //                 executeFetchInfoApplication()
                    //             })
                    //             .catch(error => {
                    //                 console.log('API ERROR: ', error)
                    //             })
                    //     }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit, FormPreInvventory } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormInvventory = FormPreInvventory.onResetForm
        onResetForm()
        onResetFormInvventory()
        closeModal()
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()
    
        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState
    
        const {fetchAllDeposits} = FetchData
        const {executeFetchAllDeposits} = fetchAllDeposits

        const {getCurrentDate} = Helpers
    
        
        if(formState.movimiento_tipo==='EFECTIVO'){
    
            const _data = {
                idcredito: formStateGlobal.idcredito,
                deposito_usuario: user.username,
                fecha_creo: getCurrentDate(),
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.deposito_quetzales,
                deposito_dolares: formState.deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones : formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            console.log(_data);
    
            await marvarApi.post( `/vehicle/common/create-deposit-cash`, _data )
                .then(({ data }) => {
    
                        alertMessage(data)
    
                        if (data.title === 'OK') {
                            onResetForm()
                            executeFetchAllDeposits()
                            closeModal()
                        }
                    
                    })
                    .catch(error => {
                            console.log('API ERROR: ', error)
                    })
    
        }
    
        if(formState.movimiento_tipo==='DEPOSITO'){
    
            if(formState.acceptedFiles.length<=0){
    
                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }
    
                alertMessage(messageCustom)
    
                return
            }
    
            const _data = new FormData();
            
            _data.append('idcredito', formStateGlobal.idcredito)
            _data.append('idbanco', formState.idbanco)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.deposito_quetzales)
            _data.append('deposito_dolares', formState.deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())
    
            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });
            
            await marvarApi.post( `/vehicle/common/create-deposit-bank`, _data )
            .then(({ data }) => {
                alertMessage(data)
                
                if (data.title === 'OK') {
                    executeFetchAllDeposits()
                    onResetForm()
                    closeModal()
                
                }
                
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })

        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_tipo_cambio} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = value !== '' ? value : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? value : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');
    
          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }
    
    }

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/common/delete-deposit/${iddeposit}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const onSubmitFormPreInventory = async (e) => {

        e.preventDefault()

        const {getCurrentDate} = Helpers

        //HOOKS
        const { FormPreInvventory:{formState}, FormRequestGlobal} = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllPreInventory:{executeFetchAllPreInventory} } = FetchData


        let _data = {
            idcredito: formStateGlobal.idcredito,
            valor: formState.valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis, 
        }


        if(formState.idvehicledeposit>0){

            if (modalOpeningMode==='EDITABLE') {
                
                _data['usuario_modifico'] = user.username; //TODO: Revisar los usuario
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put( `/vehicle/managements/pre-inventory/${formState.idvehicledeposit}`, _data )
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchAllPreInventory()
                            handleClickCloseModal()
                        }
                    
                    }).catch(error => {console.log('API ERROR: ', error)})
            }else{
                executeFetchAllPreInventory()
                handleClickCloseModal()
            }

        }else{

            _data['usuario_creo'] = user.username; //TODO: Revisar los usuario
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post( `/vehicle/managements/pre-inventory`, _data )
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllPreInventory()
                        handleClickCloseModal()
                    }
                    
                }).catch(error => {console.log('API ERROR: ', error)})
            }
            
    }


    const handleClickFetchInfoPreInventory = async (idvehicledeposit, modeOpening) => {
        
        const { FormPreInvventory: {onResetForm}} = Forms

        const { fetchInfoPreInventory : {setParamsToSearch, executeFetchPreInventory} } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idvehicledeposit: idvehicledeposit})
        executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de Pre Inventario', 'preinventory-section', {}, modeOpening)

    }

    const handleClickDeletePreInventory = (idvehicledeposit) => {

        const { fetchAllPreInventory:{executeFetchAllPreInventory} } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/managements/delete-pre-inventory/${idvehicledeposit}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllPreInventory()
                        }else{
                            
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickFetchInfoApplication = async (idcredito, idcotizacion, idvehiculo, modeOpening) => {
        
        const { FormRequestGlobal: {onResetForm, setFormState}} = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idcredito: idcredito,
            idcotizacion: idcotizacion,
            idvehiculo: idvehiculo,
        }))
        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteVehicleApplication = (idcredito) => {

        const { fetchAllVehicleApplication:{executeFetchAllVehicleApplications} } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/managements/${idcredito}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllVehicleApplications()
                        }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickUpdateState = () => {

        const {setShowForm, setStepApplilication} = globalStates
        const {getCurrentDate} = Helpers
        const {fetchAllVehicleApplication:{executeFetchAllVehicleApplications}} = FetchData
        const { FormRequestGlobal:{formState, onResetForm} } = Forms

        Swal.fire({
            title: '¿Desea enviar la solicitud al departamento de Administracion para su aprobacion?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/vehicle/legal/aprobacion-check/${formState.idcredito}`, {aprobacion_check: 'Pendiente Aprobacion Contrato', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate()})
                    .then(({ data }) => {
                        alertMessage(data)
                        if(data.title === "OK"){
                            onResetForm()
                            executeFetchAllVehicleApplications()
                                            
                            setStepApplilication(0)
                            setShowForm(false)
                        }
                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    


    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormPreInventory,
        handleClickFetchInfoPreInventory,
        handleClickDeletePreInventory,
        handleClickFetchInfoApplication,
        handleClickDeleteVehicleApplication,
        handleClickUpdateState
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}